import { render, staticRenderFns } from "./ShopsEditingUser.vue?vue&type=template&id=60b15fec"
import script from "./ShopsEditingUser.vue?vue&type=script&lang=js"
export * from "./ShopsEditingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports